import { Howl, Howler } from "howler";
import { getKV, setKV } from "../persistence/db";

/**
 * Audio mínimo (F0-T16, estética §1.4). Placeholders SINTETIZADOS — TODO-F4:
 * reemplazar por el jingle real, foley mecánico y stinger de contrabajo
 * grabados. El volumen persiste en Dexie y se controla desde Ajustes.
 */

export type SfxName = "jingle" | "pin" | "notify" | "accuse-ok" | "accuse-fail";

const sounds = new Map<SfxName, Howl>();

function howl(name: SfxName): Howl {
  let h = sounds.get(name);
  if (!h) {
    h = new Howl({ src: [`/audio/${name}.wav`] });
    sounds.set(name, h);
  }
  return h;
}

/** Dispara un SFX. Si el navegador bloquea autoplay, falla en silencio. */
export function playSfx(name: SfxName): void {
  try {
    howl(name).play();
  } catch {
    // sin gesto de usuario aún — el placeholder no amerita cola de reintento
  }
}

export async function initVolume(): Promise<void> {
  const v = await getKV<number>("volume");
  Howler.volume(v ?? 0.7);
}

export function setVolume(v: number): void {
  Howler.volume(v);
  void setKV("volume", v);
}

export function getVolume(): number {
  return Howler.volume();
}
